import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CatalogApiService } from "src/app/api/catalog-api.service";
import { Color, Lens, LensFilter, Material } from "src/app/model/catalog/catalog.model";
import { LensType } from "src/app/model/configuration/configuration";
import { Article, ArticleType, Backside, FeatureValues, LensOrderItem } from "src/app/model/order/order";
import { FinalLensComponent } from "src/app/new-order/new-order-final-lens/final-lens/final-lens.component";
import { i18nService } from "src/app/service-utils/i18n.service";
import { ReturnStoreService } from "../return-store.service";

@Component({
    selector: 'app-return-correction-dialog',
    templateUrl: './return-correction-dialog.component.html',
    styleUrls: ['./return-correction-dialog.component.scss']
  })
  export class ReturnCorrectionDialogComponent implements OnInit {

    lensFilter: LensFilter = {};

    @ViewChild('finalLens') finalLens: FinalLensComponent;

    constructor(
        public dialogRef: MatDialogRef<ReturnCorrectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public i18nService: i18nService,
        public returnStoreService: ReturnStoreService
    ) {
    }

    ngOnInit(): void {
    }

    discard(): void {
        this.dialogRef.close();
    }

    save(): void {
        if (this.finalLens.form.valid && this.finalLens.lensDetailsForm.valid){
          const lens = this.createLensOrderItem(this.finalLens);
          this.dialogRef.close(lens);
        } else {
          console.log("dialog form invalid");
        }
    }

    private createLensOrderItem(component: any): LensOrderItem {
        return {
            commission: this.getCommission(component.form),
            article: this.getArticle(component.lensFilter.families, component.form.controls['lensFamily'].value, component.form.controls['lensType'].value, component.lensFilter.backSides, component.form.controls['backSide'].value),
            count: 1,
            material: this.getMaterial(component.lensFilter.materials, component.form.controls['material'].value),
            color: this.getColor(component.lensFilter.colors, component.form.controls['color'].value),
            featureValues: this.getFeaturesValues(component.lensDetailsForm),
            isReturn: component.isReturn,
            isIndividual: component.isIndividual,
            side: component.side,
            isNew: true,
            isUpdate: false
        }
    }

    private getCommission(form: FormGroup): string {
        return form.controls['commission'].value;
    }

    private getArticle(lenses: Lens[], lensName: string, lensType: string, backside: Backside[], backsideName: string): Article {
        return {
            type: ArticleType.LENS,
            id: lenses.find(lens => lens.name === lensName).id,
            name: lensName,
            lensType: (lensType === LensType.HARD) ? LensType.HARD : LensType.SOFT,
            backSide: backside.find(lens => lens.name === backsideName),
        }
    }

    private getMaterial(materials: Material[], materialName: string): Material {
        return materials.find(material => material.name === materialName);
    }

    private getColor(colors: Color[], colorName: string): Color {
        return colors.find(color => color.name === colorName);
    }

    private getFeaturesValues(form: FormGroup): FeatureValues {
        let featureValues: FeatureValues = {};
        Object.keys(form.controls).forEach(key => {
            let value = (form.controls[key].value !== '') ? +form.controls[key].value : null;
            value = (Number.isNaN(value)) ? form.controls[key].value : value;
            featureValues[key] = value;
        });

        return featureValues;
    }

}
